export var OrderingEnum;
(function (OrderingEnum) {
    OrderingEnum[OrderingEnum["in"] = 0] = "in";
    OrderingEnum[OrderingEnum["out"] = 1] = "out";
})(OrderingEnum || (OrderingEnum = {}));
//# sourceMappingURL=orderingEnum.js.map